import type { SelectedImage } from "../../store";
import { useImagePostModalStore } from "../../store";

export const useRemoveImage = () => {
  const { setSelectedFiles, selectedFiles } = useImagePostModalStore();
  const removeImage = (file: SelectedImage) => {
    const newSelectedFiles = selectedFiles.filter(
      selectedFile => selectedFile !== file,
    );
    setSelectedFiles(newSelectedFiles);
  };

  return { removeImage };
};
